import { DataFlow, ItemDataFlow } from 'models/DataFlow'
import { Problem } from '../types/Problem'
import { t } from 'i18next'

export const checkCopyWarnings = (flows: DataFlow[]): Problem[] => {
  const blocks: ItemDataFlow[] = flows.flatMap((flow) => Object.values(flow))

  return blocks
    .filter((block) => {
      return /-copy-\d+/gi.test(block.data?.name)
    })
    .map((block) => {
      return {
        type: 'warning',
        groupId: block.data.groupId,
        blockId: block.id,
        blockName: block.data.name,
        message: t('linter.warnings.copyMessage'),
      }
    })
}
